<div class="complaint-appointment__input">
    <icc-input
        *ngIf="!editMode"
        type="date"
        [name]="'appointmentDate'"
        [value]="complaintAppointment.date"
        [size]="'medium'"
        [required]="true"
        (valueChange)="complaintAppointment.date = $event"
        [datePickerSide]="'left'"
        [min]="minDate"
        [placeholder]="'COMPLAINT_APPOINTMENT|Data wizyty' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Data wizyty' | translate"
        [dateErrorMessage]="isDateInvalid(complaintAppointment.date) ? ('COMPLAINT_APPOINTMENT|Nie można wprowadzić daty wcześniejszej niż dzisiejsza' | translate) : ('COMPLAINT_APPOINTMENT|Wprowadź datę w formacie: dd.mm.rrrr' | translate)"
    ></icc-input>
    <icc-input
        *ngIf="editMode"
        type="date"
        [name]="'appointmentDate'"
        [value]="complaintAppointment.date"
        [size]="'medium'"
        [required]="true"
        (valueChange)="onDateChange($event)"
        [datePickerSide]="'left'"
        [min]="initialDate"
        [placeholder]="'COMPLAINT_APPOINTMENT|Data wizyty' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Data wizyty' | translate"
        [dateErrorMessage]="!isDateInvalidEditMode($event) ? ('COMPLAINT_APPOINTMENT|Nie można wprowadzić daty wcześniejszej niż dzisiejsza' | translate) : ('COMPLAINT_APPOINTMENT|Wprowadź datę w formacie: dd.mm.rrrr' | translate)"
    ></icc-input>
</div>

<div class="complaint-appointment__input">
    <icc-input
        type="text"
        [name]="'appointmentTime'"
        [value]="complaintAppointment.time"
        [size]="'medium'"
        [required]="false"
        (valueChange)="complaintAppointment.time = $event"
        [placeholder]="'COMPLAINT_APPOINTMENT|Godzina wizyty' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Godzina wizyty' | translate"
        [prefixIcon]="'time'"
        [supportText]="'COMPLAINT_APPOINTMENT|Wprowadź godzinę w formacie: gg:mm' | translate"
        [maxLength]="5"
    ></icc-input>
</div>

<div class="complaint-appointment__input">
    <icc-input
        type="number"
        [name]="'scheduledTime'"
        [value]="complaintAppointment.scheduledTime"
        [size]="'medium'"
        [required]="false"
        (valueChange)="complaintAppointment.scheduledTime = $event"
        [placeholder]="'COMPLAINT_APPOINTMENT|Planowany czas (w minutach)' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Planowany czas' | translate"
        [prefixIcon]="'timer'"
    ></icc-input>
</div>

<div *ngIf="editMode" class="complaint-appointment__input">
    <icc-input
        type="number"
        [name]="'timeUsed'"
        [value]="complaintAppointment.timeUsed"
        [size]="'medium'"
        [required]="false"
        (valueChange)="complaintAppointment.timeUsed = $event"
        [placeholder]="'COMPLAINT_APPOINTMENT|Wykorzystany czas (w minutach)' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Wykorzystany czas' | translate"
        [prefixIcon]="'timer'"
    ></icc-input>
</div>

<div class="complaint-appointment__select">
    <icc-select
        [label]="'COMPLAINT_APPOINTMENT|Status wizyty' | translate"
        [value]="complaintAppointment.status"
        id="complaintAppointmentStatus"
        (valueChange)="complaintAppointment.status = $event"
        size="medium"
        [required]="false"
        [prefixIcon]="'configure'"
        appearance="outline"
    >
        <option
            *ngFor="let status of appointmentStatuses"
            [value]="status.value"
        >
            {{ status.label | translate }}
        </option>
    </icc-select>
</div>

<div class="complaint-appointment__select">
    <icc-select
        [value]="complaintAppointment.assignedUserId"
        [label]="'COMPLAINT_APPOINTMENT|Osoba odpowiedzialna za wizytę' | translate"
        id="complaintAppointmentPerson"
        (valueChange)="complaintAppointment.assignedUserId = $event"
        size="medium"
        [required]="false"
        [prefixIcon]="'person'"
        appearance="outline"
    >
        <option
            *ngFor='let worker of workersList | keyvalue'
            [value]="worker.key"
        >
            {{ worker.value }}
        </option>
    </icc-select>
</div>

<div class="complaint-appointment__input">
    <icc-input
        type="textarea"
        [name]="'appointmentComment'"
        [value]="complaintAppointment.comment"
        [size]="'medium'"
        [required]="false"
        (valueChange)="complaintAppointment.comment= $event"
        [prefixIcon]="'edit'"
        [rows]="3"
        [placeholder]="'COMPLAINT_APPOINTMENT|Komentarz' | translate"
        [label]="'COMPLAINT_APPOINTMENT|Komentarz' | translate"
    ></icc-input>
</div>

<div class="complaint-appointment__attachments-input">
    <label [for]="'appointmentAttachment' + complaintAppointment.uuid" style="cursor: pointer;">
        <icc-icon name="add_photo"></icc-icon>{{ ('INTERFACE|Dodaj' | translate) }}
    </label>
    <input
        type="file"
        accept="application/pdf, image/jpeg, image/png"
        [id]="'appointmentAttachment' + complaintAppointment.uuid"
        (change)="onAddAttachment($event.target.files, 'appointmentAttachment')"
    >
</div>

<div *ngIf="getAttachments('appointmentAttachment').length > 0" class="complaint-appointment__attachments-container">
    <div class="appointment-attachments">
        <div class="appointment-attachments-body" *ngFor="let appointmentAttachment of complaintAppointmentAttachments; index as i">
            <div class="filename">
                <span *ngIf="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name" [title]="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name">{{ getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.name }}</span>
            </div>
            <div class="input">
                <icc-input
                    type="text"
                    [name]="'appointmentAttachmentDescription' + appointmentAttachment.uuid"
                    [size]="'medium'"
                    [value]="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)?.description"
                    (valueChange)="getAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid).description = $event"
                    [placeholder]="'COMPLAINT|Załącznik #{i} - opcjonalny tytuł' | translate: {i: (i + 1)}"
                ></icc-input>
            </div>
            <div style="cursor: pointer;">
                <icc-icon name="delete" (click)="removeAttachment(appointmentAttachment.attachmentType, appointmentAttachment.uuid)"></icc-icon>
            </div>
        </div>
    </div>
</div>

